import { gql } from '@apollo/client';

/**
 * GraphQL mutation for updating a community
 *
 * Note: This mutation is not yet implemented in the BFF.
 * It will need to be added to the schema and implemented in the resolver.
 */
export const UPDATE_COMMUNITY = gql`
  mutation UpdateCommunity($id: ID!, $input: UpdateCommunityInput!) {
    updateCommunity(id: $id, input: $input) {
      id
      name
      communityGroupId
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      securityGroups {
        admin
        moderator
        user
      }
      createdAt
      createdBy
      lastModifiedAt
      lastModifiedBy
    }
  }
`;
